import React, {useContext, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {createProduct, getCategory} from '../bs-product-list/core/_requests'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {useQueryResponse} from '../bs-product-list/core/QueryResponseProvider'

//Model Interface
export interface IProfileDetails {
  name: string
  category_id: string

  image: any
  formImage: any
  createdBy: string | undefined
}

//Model Initial Value
export let initialValues: IProfileDetails = {
  name: '',
  category_id: '',

  image: '',
  formImage: '',

  createdBy: '',
}

//Validation
const roleDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Product name is required'),
  category_id: Yup.string().required('Category is required'),
})

//Function Starts
const RoleDetails: React.FC = () => {
  const {showAlert} = useContext(AlertContext)
  const {refetch} = useQueryResponse()
  const [data, setData] = useState<IProfileDetails>(initialValues)
  const navigate = useNavigate()
  const [formImage, setFormImage] = useState<File | null>(null)

  //Image Target
  interface Event<T = EventTarget> {
    target: T
    // ...
  }

  //Image Handler
  const imageHandler = (e: Event<HTMLInputElement>) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (reader.readyState === 2) {
        setData({
          ...data,
          image: reader.result,
        })
      }
    }
    const files = e.target.files
    if (files) {
      setFormImage(files[0])
      reader.readAsDataURL(files[0])
    }
  }

  //Get Current User in useAuth() to get createdBy, type
  const {currentUser} = useAuth()
  const type = currentUser?.type
  const [loading, setLoading] = useState(false)
  //formik Starts
  const formik = useFormik<IProfileDetails>({
    initialValues,
    validationSchema: roleDetailsSchema,

    //Form Submit
    onSubmit: (values, {resetForm}) => {
      setLoading(true)
      const updatedData = Object.assign(data, values)
      updatedData.createdBy = currentUser?.userId

      //Image and data Append to Form Data
      const formData = new FormData()
      //image append to formData
      if (formImage) formData.append('image', formImage)

      //updatedData append to formData
      Object.entries(updatedData).forEach(([key, value]) => formData.append(key, value))

      createProduct(formData).then((res) => {
        

        resetForm({
          ...initialValues,
          values: {...initialValues},
        })
        setData(initialValues)
        navigate('/bsProduct', {replace: true})
        refetch()
        setLoading(false)
        showAlert(res?.data?.Message, res?.data?.Code)
      })
    },
    enableReinitialize: true,
  })

  // Get role using type
  const [category, setcategory] = useState<any>([])
  useEffect(() => {
    getCategory().then((res: any) => {
      setcategory(res.data.data)
      
    })
  }, [])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Add Product </h3>
        </div>
      </div>

      <div id='kt_account_profile_details'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/** Company Info */}
            {/** Profile Image */}
            <div className='row mb-6'>
              <div className='col-lg-8'>
                <label className='col-lg-12 col-form-label fw-bold fs-6'>Product Picture</label>
                <div
                  className='image-input image-input-outline'
                  data-kt-image-input='true'
                  style={{backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`}}
                >
                  {typeof data?.image === 'string' ? (
                    <div
                      className='image-input-wrapper w-125px h-125px'
                      style={{backgroundImage: `url(${data.image})`}}
                    ></div>
                  ) : (
                    <div
                      className='image-input-wrapper w-125px h-125px'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`,
                      }}
                    ></div>
                  )}
                  <label
                    className='btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow'
                    data-kt-image-input-action='change'
                    data-bs-toggle='tooltip'
                    data-bs-dismiss='click'
                    title='Change Profile image'
                  >
                    <i className='bi bi-pencil-fill fs-7'></i>
                    <input
                      type='file'
                      name='avatar'
                      onChange={imageHandler}
                      accept='.png, .jpg, .jpeg'
                    />
                  </label>
                  {/* <!--end::Edit button--> */}
                  {/* <!--begin::Remove button--> */}
                  {data.image && (
                    <span
                      className='btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='remove'
                      onClick={() => {
                        setData({
                          ...data,
                          image: null,
                        })
                      }}
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Remove Profile image'
                    >
                      <i className='bi bi-x fs-2'></i>
                    </span>
                  )}
                </div>
                {data.image ? (
                  ''
                ) : (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>Please upload profile</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Product Name</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Enter Product Name'
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Category</label>
                  <select
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Role'
                    {...formik.getFieldProps('category_id')}
                  >
                    <option value=''>Select a Category</option>
                    {category.map((item: any, i: any) => {
                      return (
                        <option key={i} value={item.id}>
                          {item.name}
                        </option>
                      )
                    })}
                  </select>
                  {formik.touched.category_id && formik.errors.category_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.category_id}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {!loading && 'Save Changes'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default RoleDetails
